import {AsyncInlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

import {GenericAuthenticationrError} from '../Errors/GenericAuthenticationError.js'

export default class NotifyAuthenticationPasswordService extends Service {
  constructor({repository}) {
    super({repository})

    this._repository = repository
  }

  _isPasswordReset(gigyaEvent) {
    return gigyaEvent.isAfterSubmit() && gigyaEvent.onResetPasswordScreen()
  }

  @AsyncInlineError()
  async execute({gigyaEventAuthenticationValueObject: gigyaEvent}) {
    if (!gigyaEvent.isStatusSuccess())
      return Promise.reject(GenericAuthenticationrError.create({message: 'Gigya status Error'}))

    if (this._isPasswordReset(gigyaEvent)) {
      return this._repository.notifyResetPassword({UID: gigyaEvent.getUID()})
    }

    return Promise.resolve()
  }
}
